



import React, { useState } from 'react';
import { motion } from 'framer-motion';
import {
  MapPin,
  Star,
  ThumbsUp,
  Users,
  Building2,
  Calendar,
  Bed,
  Award,
  Image
} from 'lucide-react';
import MedtrustHeader from '../../Compoents/MedtrustHeader';
import MedtrustFooter from '../../Compoents/MedtrustFooter';
import { CheckCircle, MessageCircle, ChevronRight, Check } from "lucide-react";
import {
  FaHospital,
  FaDollarSign,
  FaUserMd,
  FaClock,
  FaGlobe,
  FaBriefcaseMedical,
  
} from "react-icons/fa";



const DoctorCard = ({ doctor }) => {
  return (
    <div className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow">
      <div className="flex items-start gap-4 mb-4">
        <img
          src={doctor.image}
          alt={doctor.name}
          className="w-24 h-24 rounded-lg object-cover"
        />
        <div className="flex-1">
          <h3 className="text-xl font-bold text-gray-800 mb-1">{doctor.name}</h3>
          <p className="text-gray-600 mb-2">{doctor.specialization}</p>
          {doctor.rating && (
            <div className="flex items-center gap-2 mb-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={18}
                    className={`${i < Math.floor(doctor.rating)
                        ? 'fill-yellow-400 text-yellow-400'
                        : i < doctor.rating
                          ? 'fill-yellow-400 text-yellow-400'
                          : 'fill-gray-300 text-gray-300'
                      }`}
                  />
                ))}
              </div>
              <span className="text-sm font-semibold text-gray-700">
                {doctor.rating} ({doctor.ratingCount} Ratings)
              </span>
            </div>
          )}
          <p className="text-gray-700 font-medium">{doctor.experience} years of experience</p>
        </div>
      </div>

      <div className="flex gap-3">
        <button className="flex-1 bg-red-500 hover:bg-red-600 text-white  py-3 px-4 rounded-lg transition-colors">
          Book Appointment
        </button>
        <button className="flex-1 bg-green-500 hover:bg-green-600 text-white py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2">
          <MessageCircle size={20} />
          Whatsapp Us
        </button>
      </div>
    </div>
  );
};

const Terms = () => {


   const mainFeatures = [
    {
      title: 'Experienced Medical Team:',
      description: 'Indraprastha Apollo has a team of over 95 highly skilled senior consultants, supported by an extensive network of Apollo Hospitals Group.'
    },
    {
      title: 'Specialities:',
      description: 'It offers comprehensive care across more than 50 super specialities, ensuring that all patient needs are addressed under one roof.'
    },
    {
      title: 'Centres of Excellence:',
      description: 'The hospital features several Centres of Excellence, each delivering world-class care through expert teams and advanced medical technology.'
    }
  ];

  const centres = [
    {
      name: 'Heart Institute:',
      description: 'A premier centre for cardiac care offering a full spectrum of services from interventional cardiology to robotic cardiac surgery, backed by exceptional success rates.'
    },
    {
      name: 'Apollo Institutes of Transplant:',
      description: 'A globally recognised leader in liver, kidney, and bone marrow transplants. It is renowned for pioneering paediatric liver transplants in India and is one of the busiest transplant programmes in the world.'
    },
    {
      name: 'Institute of Neurosciences:',
      description: 'Specialises in treating complex neurological conditions, offering advanced care for stroke, epilepsy, and spinal disorders with the aid of cutting-edge navigation technology.'
    },
    {
      name: 'Cancer Institute:',
      description: 'A comprehensive oncology centre providing advanced, multidisciplinary cancer care through surgical, medical, and radiation oncology, including robotic surgery and precision radiotherapy.'
    },
    {
      name: 'Institute of Orthopaedics:',
      description: 'Offers a wide range of orthopaedic services, including robotic joint replacements, sports medicine, and minimally invasive spine surgery.'
    }
  ];


  return (
   
      <div className="mx-auto rounded-3xl md:p-8">
        <h1 className="flex-1 text-center text-4xl md:text-5xl font-bold text-gray-800 mb-12">
          Team and Specialities
        </h1>

        <div className="space-y-6 mb-8">
          {mainFeatures.map((feature, index) => (
            <div key={index} className="flex gap-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircle className="w-6 h-6 text-green-600 fill-green-600" />
              </div>
              <div>
                <span className="font-bold text-gray-800 text-2xl">
                  {feature.title}
                </span>
                <span className="text-gray-700 text-xl">
                  {' '}{feature.description}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="ml-10 space-y-6">
          {centres.map((centre, index) => (
            <div key={index} className="flex gap-4">
              <div className="flex-shrink-0 mt-2">
                <div className="w-2 h-2 bg-gray-700 rounded-full"></div>
              </div>
              <div>
                <span className="font-bold text-gray-800 text-xl">
                  {centre.name}
                </span>
                <span className="text-gray-700 text-lg">
                  {' '}{centre.description}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
   
  );
}


const FacilitiesAccordion = () => {
  const [activeSection, setActiveSection] = useState('comfort');

  const facilities = {
    comfort: {
      title: 'Comfort During Stay',
      items: [
        'TV in room',
        'Free Wifi',
        'Mobility accessible rooms',
        'Laundry',
        'Safe in the room',
        'Dry cleaning',
        'Religious facilities',
        'Spa and wellness',
        'Business centre services',
        'Dedicated smoking areas',
        'Special offer for group stays',
        'Private rooms',
        'Phone in Room',
        'Family accommodation',
        'Welcome',
        'Nursery / Nanny services',
        'Personal assistance / Concierge',
        'Fitness',
        'Café',
        'Shop',
        'Beauty Salon',
        'Parking available'
      ]
    },
    money: {
      title: 'Money Matters',
      items: [
        'Credit cards accepted',
        'Currency exchange',
        'ATM available',
        'Free cancellation',
        'No prepayment needed',
        'Payment at property'
      ]
    },
    food: {
      title: 'Food',
      items: [
        'Restaurant',
        'Room service',
        'Bar',
        'Breakfast available',
        'Packed lunches',
        'Special diet menus',
        'Kids meals',
        'Mini bar'
      ]
    },
    treatment: {
      title: 'Treatment Related',
      items: [
        'Medical services',
        'Pharmacy',
        'Emergency room',
        'Doctor on call',
        'Nursing services',
        'Laboratory',
        'Ambulance service',
        'Medical equipment'
      ]
    },
    language: {
      title: 'Language',
      items: [
        'English',
        'Hindi',
        'Spanish',
        'French',
        'German',
        'Chinese',
        'Arabic',
        'Japanese'
      ]
    },
    transportation: {
      title: 'Transportation',
      items: [
        'Airport shuttle',
        'Car rental',
        'Taxi service',
        'Public transport tickets',
        'Bicycle rental',
        'Shuttle service',
        'Private driver',
        'Parking garage'
      ]
    }
  };

  const handleSectionClick = (section) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <div className=" mx-auto p-8">
      <h1 className="flex-1 text-center text-4xl md:text-5xl font-bold text-gray-800 my-8">Facilities</h1>
      
      <div className="flex gap-8 md:gap-[100px]">
        {/* Left sidebar with categories */}
        <div className="flex flex-col gap-3 w-80">
          {Object.keys(facilities).map((key) => (
            <button
              key={key}
              onClick={() => handleSectionClick(key)}
              className={`flex items-center justify-between px-6 py-4 rounded-lg font-semibold text-lg md:text-xl transition-all ${
                activeSection === key
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-blue-100 text-gray-800 hover:bg-blue-200'
              }`}
            >
              <span>{facilities[key].title}</span>
              <ChevronRight 
                className={`w-5 h-5 transition-transform ${
                  activeSection === key ? 'rotate-180' : ''
                }`}
              />
            </button>
          ))}
        </div>

        {/* Right side with facility items */}
        <div className="flex-2">
          {activeSection && (
            <div className="grid grid-cols-2 gap-x-12 gap-y-4">
              {facilities[activeSection].items.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <div className="flex-shrink-0 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                  <span className="text-gray-800 text-lg md:text-2xl">{item}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};






const OurHospital = () => {
  const [formData, setFormData] = useState({
    patientName: '',
    country: 'India',
    city: '',
    phone: '',
    problem: '',
    age: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    alert('Details submitted successfully!');
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const doctors = [
    {
      id: 1,
      name: 'Dr. Rakesh Mahajan',
      specialization: 'Vascular Surgeon',
      experience: 40,
      rating: 5.0,
      image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=200&h=200&fit=crop',
    },
    {
      id: 2,
      name: 'Dr. P. L. Dhingra',
      specialization: 'ENT Surgeon',
      experience: 51,
      rating: 5.0,
      ratingCount: 13,
      image: 'https://images.unsplash.com/photo-1622253692010-333f2da6031d?w=200&h=200&fit=crop',
    },
    {
      id: 3,
      name: 'Dr. Shakti Bhan Khanna',
      specialization: 'Gynaecologist and Obstetrician',
      experience: 66,
      rating: 4.8,
      ratingCount: 14,
      image: 'https://images.unsplash.com/photo-1594824476967-48c8b964273f?w=200&h=200&fit=crop',
    },
    {
      id: 4,
      name: 'Dr. Subhash Wangnoo',
      specialization: 'Endocrinologist',
      experience: 35,
      rating: 5.0,
      image: 'https://images.unsplash.com/photo-1537368910025-700350fe46c7?w=200&h=200&fit=crop',
    },
  ];

 





  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-950 to-blue-600 text-white">
      <MedtrustHeader />

      <div className="mt-[100px] bg-white ">
        <div className="py-10 px-5 sm:px-8 md:px-10">
          {/* Header Section */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="mb-6"
          >
            <div className="flex flex-wrap items-center gap-2 mb-3 text-center sm:text-left justify-center sm:justify-start">
              <Star className="w-5 h-5 text-yellow-500 fill-yellow-500" />
              <span className="text-red-600 font-semibold text-sm sm:text-base">
                You are viewing our top rated Hospital
              </span>
            </div>

            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
              <div className="text-center sm:text-left">
                <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800 mb-2 leading-snug">
                  Jinshazhou Hospital of Guangzhou University of Chinese Medicine
                </h1>
                <div className="flex flex-wrap items-center justify-center sm:justify-start gap-3">
                  <div className="flex items-center gap-2 text-sm sm:text-base">
                    <MapPin className="w-5 h-5 text-gray-500" />
                    <span className="text-gray-600">New Delhi, India</span>
                  </div>
                  <div className="flex items-center gap-1">
                    {[...Array(4)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                    ))}
                    <Star className="w-4 h-4 text-yellow-500 fill-yellow-500 opacity-50" />
                    <span className="text-gray-700 font-semibold text-sm sm:text-base ml-1">
                      4.3 (86 Ratings)
                    </span>
                  </div>
                </div>
              </div>

              {/* Recommendation Box */}
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="bg-green-50 border-2 border-green-500 rounded-2xl px-5 py-3 flex items-center gap-3 self-center sm:self-auto mx-auto sm:mx-0"
              >
                <ThumbsUp className="w-8 h-8 text-green-600" />
                <div>
                  <div className="text-xl sm:text-2xl font-bold text-gray-800">95% Patients</div>
                  <div className="text-xs sm:text-sm text-gray-600">recommended this hospital</div>
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* Main Content Grid */}
          <div className="grid lg:grid-cols-2 gap-8">
            {/* Left Column */}
            <div className="lg:col-span-2 space-y-6">
              {/* Hospital Images */}
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="grid grid-cols-1 md:grid-cols-2 gap-4"
              >
                <div className="bg-gradient-to-br from-blue-100 to-blue-200 rounded-3xl h-[400px] sm:h-[550px] overflow-hidden">
                  <div className="w-full h-full bg-gray-300 flex items-center justify-center">
                   <img
                  src='https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&h=400&fit=crop'
               alt=''
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
  />
                  </div>
                </div>
                <div className="bg-gradient-to-br from-gray-100 to-gray-200 rounded-3xl h-[400px] sm:h-[550px] overflow-hidden">
                  <div className="w-full h-full bg-gray-300 flex items-center justify-center">
                     <img
                  src='https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=600&h=400&fit=crop'
               alt=''
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
  />
                  </div>
                </div>
              </motion.div>
              {/* <FacilityCard /> */}

              {/* Table Info */}

              <div className="overflow-hidden rounded-2xl border border-gray-200 shadow-sm">
                <table className="w-full text-sm sm:text-base">
                  <tbody>
                    <tr className="bg-white hover:bg-gray-50 transition">
                      <td className="p-4 border">
                        <div className="flex items-center gap-3">
                          <Users className="w-6 h-6 text-blue-600" />
                          <div>
                            <div className="font-semibold text-gray-800">Doctors List</div>
                            <button className="text-blue-600 text-sm hover:underline">Click Here</button>
                          </div>
                        </div>
                      </td>
                      <td className="p-4 border border-gray-200 hidden sm:table-cell">
                        <div className="flex items-center gap-3">
                          <MapPin className="w-6 h-6 text-blue-600" />
                          <div>
                            <div className="font-semibold text-gray-800">Location</div>
                            <div className="text-gray-600">New Delhi</div>
                          </div>
                        </div>
                      </td>
                      <td className="p-4 border border-gray-200 hidden md:table-cell">
                        <div className="flex items-center gap-3">
                          <Calendar className="w-6 h-6 text-blue-600" />
                          <div>
                            <div className="font-semibold text-gray-800">Established</div>
                            <div className="text-gray-600">1995</div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr className="bg-white hover:bg-gray-50 transition">
                      <td className="p-4 border border-gray-200">
                        <div className="flex items-center gap-3">
                          <Award className="w-6 h-6 text-blue-600" />
                          <div>
                            <div className="font-semibold text-gray-800">Specialty</div>
                            <div className="text-gray-600">Multi Specialty</div>
                          </div>
                        </div>
                      </td>
                      <td className="p-4 border border-gray-200 hidden sm:table-cell">
                        <div className="flex items-center gap-3">
                          <Image className="w-6 h-6 text-blue-600" />
                          <div>
                            <div className="font-semibold text-gray-800">Images</div>
                            <button className="text-blue-600 text-sm hover:underline">Click Here</button>
                          </div>
                        </div>
                      </td>
                      <td className="p-4 border border-gray-200 hidden md:table-cell">
                        <div className="flex items-center gap-3">
                          <Bed className="w-6 h-6 text-blue-600" />
                          <div>
                            <div className="font-semibold text-gray-800">Beds</div>
                            <div className="text-gray-600">710</div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* </motion.div> */}

              {/* Buttons */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.6 }}
                className="flex flex-col sm:flex-row gap-10"
              >
                <motion.button
                  whileHover={{ scale: 1.01 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-full sm:flex-1 bg-red-500 hover:bg-red-600 text-white font-semibold py-4 px-10 rounded-xl shadow-lg"
                >
                  Book Appointment For Hospital
                </motion.button>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white font-semibold py-4 px-6 rounded-xl shadow-lg flex items-center justify-center gap-2"
                >
                  <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967..." />
                  </svg>
                  Whatsapp Us
                </motion.button>
              </motion.div>
            </div>

            {/* Right Column - Form */}
            {/* <motion.div
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="lg:col-span-1"
            >
              <div className="bg-blue-900 rounded-3xl p-6 sm:p-8 shadow-xl mt-10 lg:mt-0">
                <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">
                  Contact Hospital
                </h2>
                <p className="text-blue-200 mb-6 text-sm sm:text-base">
                  Treatment plan and quote within 2 days
                </p>

                <div className="space-y-4">
                  <input
                    type="text"
                    name="patientName"
                    placeholder="Patient Name"
                    value={formData.patientName}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-400"
                  />

                  <select
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-full bg-white text-gray-800 focus:ring-2 focus:ring-blue-400"
                  >
                    <option>India</option>
                    <option>USA</option>
                    <option>UK</option>
                    <option>Canada</option>
                  </select>

                  <input
                    type="text"
                    name="city"
                    placeholder="Select City"
                    value={formData.city}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-400"
                  />

                  <div className="flex gap-2">
                    <input
                      type="text"
                      value="+91"
                      readOnly
                      className="flex-1 px-4 py-3 rounded-lg bg-white text-gray-800 text-center w-50 sm:w-50"
                    />
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Your Phone Number"
                      value={formData.phone}
                      onChange={handleChange}
                      className="flex-1 px-4 py-3 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-400"
                    />
                  </div>

                  <textarea
                    name="problem"
                    placeholder="Describe The Current Medical Problem .."
                    value={formData.problem}
                    onChange={handleChange}
                    rows="4"
                    className="w-full px-4 py-3 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-400 resize-none"
                  />

                  <input
                    type="text"
                    name="age"
                    placeholder="Example: 30 Yrs or 29-05-1985"
                    value={formData.age}
                    onChange={handleChange}
                    className="w-full px-4 py-3 rounded-lg bg-white text-gray-800 placeholder-gray-400 focus:ring-2 focus:ring-blue-400"
                  />

                  <motion.button
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    onClick={handleSubmit}
                    className="w-full bg-red-500 hover:bg-red-600 text-white font-bold py-4 rounded-lg shadow-lg"
                  >
                    SUBMIT DETAILS
                  </motion.button>

                  <p className="text-xs text-blue-200 text-center">
                    By submitting the form I agree to the Terms of Use and Privacy Policy.
                  </p>
                </div>
              </div>
            </motion.div> */}

          </div>
        </div>
        <section className='flex-1 px-9'>
          <div className="max-w-full mx-auto px-6 py-10 text-gray-800 leading-relaxed">
            <h2 className="flex-1 text-4xl md:text-5xl text-center font-bold mb-8">About Hospital</h2>

            <div className="space-y-6">
              <p className="flex items-start">
                <CheckCircle className="text-green-500 mt-1 mr-3" />
                The Great Hospital, the Great Hospitals Group's flagship, is
                India's premier multi-super specialty hospital. It was founded as a
                joint venture with the Government of Delhi and has constantly ranked at
                the top of medical quality.
              </p>

              <p className="flex items-start">
                <CheckCircle className="text-green-500 mt-1 mr-3" />
                The Great, India's first hospital to be globally recognised
                by JCI in 2005, has established itself as a worldwide leader in organ
                transplantation and cardiac sciences.
              </p>

              <div className="flex items-start">
                <CheckCircle className="text-green-500 mt-1 mr-3 flex-shrink-0" />
                <div>
                  <p>
                    The Great has earned numerous prestigious awards and
                    recognitions, including:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
                    <li>
                      It is the first hospital in India to be accredited by JCI (2005)
                      and has been consecutively re-accredited.
                    </li>
                    <li>
                      Featured among the World's Best Hospitals in the Newsweek survey
                      (2025).
                    </li>
                    <li>
                      FICCI Medical Value Travel Award for the Best Private Hospital
                      for Medical Tourism (2019).
                    </li>
                    <li>
                      Golden Peacock Award for excellence in Risk Management.
                    </li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start">
                <CheckCircle className="text-green-500 mt-1 mr-3 flex-shrink-0" />
                <div>
                  <p>
                    The hospital has achieved many groundbreaking milestones and holds
                    extensive records in clinical excellence, such as:
                  </p>
                  <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
                    <li>
                      Performed India's first successful paediatric liver transplant in
                      1998.
                    </li>
                    <li>
                      One of the world's busiest solid organ transplant centres, with
                      over 500 paediatric liver transplants performed by 2011.
                    </li>
                    <li>
                      Achieved a 99.6% success rate in cardiac bypass (CABG) surgeries,
                      with 91% performed on a beating heart.
                    </li>
                    <li>
                      A pioneer in robotic surgery across multiple specialties.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <h3 className="font-semibold text-lg mt-10">
              International Patient Services
            </h3>
            <p className="mt-2">
              The Great is a preferred destination for international
              patients, offering comprehensive and personalised care:
            </p>

            <div className="space-y-4 mt-4">
              <p className="flex items-start">
                <CheckCircle className="text-green-500 mt-1 mr-3" />
                <span>
                  <strong>Pre-arrival Consultation and Case Review:</strong> Patients
                  can receive medical opinions and treatment cost estimates from senior
                  consultants prior to their visit.
                </span>
              </p>

              <p className="flex items-start">
                <CheckCircle className="text-green-500 mt-1 mr-3" />
                <span>
                  <strong>Visa & Travel Assistance:</strong> The hospital provides
                  medical visa invitation letters and support for travel arrangements.
                </span>
              </p>
            </div>
          </div>
        </section>


        <section className=" py-5 px-4 my-5">
          <div className="max-w-full mx-4">
            <h1 className="flex-1 text-center text-3xl md:text-5xl font-bold text-gray-800 mb-10">
              Top Doctors at The Great Hospital, New Delhi
            </h1>

            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6 mb-8">
              {doctors.map((doctor) => (
                <DoctorCard key={doctor.id} doctor={doctor} />
              ))}
            </div>

            <div className="flex justify-center">
              <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition-colors">
                See More
              </button>
            </div>
          </div>
        </section>
       
          

        <section className='flex p-10 bg-red-50'>
          <Terms />
        </section>

        <section>
          <FacilitiesAccordion />
        </section>

       


        

      </div>


      <MedtrustFooter />
    </div>
  );
};

export default OurHospital;



const FacilityCard = () => {

  const cardData = [
    {
      icon: <FaHospital />,
      title: "Location",
      description:
        "Find extensive information on hospitals & doctors that can treat you. Compare prices, reviews, qualifications & facilities.",
    },
    {
      icon: <FaDollarSign />,
      title: "Get free Expert Opinion",
      description:
        "Use our inquiry forms to contact providers of interest. Receive an expert medical opinion and treatment cost estimate.",
    },
    {
      icon: <FaUserMd />,
      title: "Expert Medical Professionals",
      description:
        "Connect with internationally trained doctors and specialists in various medical fields.",
    },
    {
      icon: <FaClock />,
      title: "Select Provider",
      description:
        "Finalize the right provider for your treatment. Make an informed decision.",
    },
    {
      icon: <FaGlobe />,
      title: "Plan Your Trip",
      description:
        "Once you decide, our hospital coordinators will help to schedule appointments, accommodation and all other logistics.",
    },
    {
      icon: <FaBriefcaseMedical />,
      title: "Return Home Fit",
      description:
        "Get cured, pay hospital after treatment and return home safe. Our care team is available throughout your journey to good health!",
    },
    
  ];

  return (
    <div
      className="container py-5"
      style={{
        background: "linear-gradient(to bottom right, #ffffffff, #ffffffff)",
        borderRadius: "18px",
      }}
    >
      <div className="row g-4">
        {cardData.map((card, index) => (
          <div className="col-12 col-sm-6 col-lg-4" key={index}>
            <div
              className="service-item-2 fade-top card h-100 rounded-4 text-center p-3 border-1 border-gray-200 transition-all duration-300 hover:-translate-y-2"
              style={{
                background:
                  "linear-gradient(180deg, #E2EEFF 0%, rgba(255, 255, 255, 0) 50%)",
              }}
            >
              <div
                className="icon mx-auto mb-3 d-flex align-items-center justify-content-center "
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "50%",
                  width: "70px",
                  height: "70px",
                  // fontSize: "1.5rem",
                  color: "#276CF5",
                }}
              >
                {card.icon ? (
                  card.icon
                ) : (
                  <img
                    src={card.iconSrc}
                    alt="icon"
                    style={{ width: "40px", height: "40px" }}
                  />
                )}
              </div>
              <div className="card-body px-2 content">
                <h5 className="card-title fw-semibold title">
                  <a
                    href={card.link || "#"}
                    style={{ textDecoration: "none", color: "inherit" }}
                  >
                    {card.title}
                  </a>
                </h5>
               
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};